const stationsDe = {
  AIG: 'Aigle',
  ALT: 'Altdorf',
  ANT: 'Andermatt',
  RAG: 'Bad Ragaz',
  BAS: 'Basel',
  BER: 'Bern',
  CHM: 'Chaumont',
  CHD: 'Château-d’Oex',
  GSB: 'Col du Grand St-Bernard',
  DAV: 'Davos',
  ELM: 'Elm',
  ENG: 'Engelberg',
  GVE: 'Genf',
  GRH: 'Grimsel Hospiz',
  GRC: 'Grächen',
  JUN: 'Jungfraujoch',
  CDF: 'La Chaux-de-Fonds',
  LCR: 'La Cure',
  DAB: 'Les Diablerets',
  OTL: 'Locarno',
  LUG: 'Lugano',
  LUZ: 'Luzern',
  MER: 'Meiringen',
  NEU: 'Neuenburg',
  PAY: 'Payerne',
  SAM: 'Samedan',
  SBE: 'San Bernardino',
  SIA: 'Sils Maria',
  SIO: 'Sitten',
  STG: 'St. Gallen',
  SAE: 'Säntis',
  YVD: 'Yverdon-les-Bains',
  SMA: 'Zürich',
}

export { stationsDe }
